import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const MimicsGlyph = /*#__PURE__*/createElement("g", {
  id: "Mimics"
}, /*#__PURE__*/createElement("path", {
  d: "M67.92,62.32H21.68V16.08c0-0.8-0.65-1.46-1.46-1.46s-1.45,0.65-1.45,1.46v46.24h-2.69c-0.8,0-1.46,0.65-1.46,1.46 s0.65,1.46,1.46,1.46h2.69v2.69c0,0.8,0.65,1.46,1.45,1.46s1.46-0.65,1.46-1.46v-2.69h46.24c0.8,0,1.46-0.65,1.46-1.46 S68.72,62.32,67.92,62.32z"
}));
const Mimics = createSvg({
  name: 'Mimics',
  path: MimicsGlyph
});

export default Mimics;
export { MimicsGlyph };
